import React from "react";
import PropTypes from "prop-types";
import styles from "./CheckBox.module.scss";

const CheckBox = ({
  id,
  label,
  checked = false,
  isDisabled = false,
  handleOnChange,
  isFordBrand = true,
  boldCheck = false,
  hideCheckbox = false,
  textClass = "",
  // Accessibility props (all optional)
  ariaLabel,
  ariaLabelledby,
  ariaDescribedby,
  ariaChecked,
  ariaDisabled,
  role,
}) => {
  const handleCheckboxOnChange = (e) => {
    if (!isDisabled && handleOnChange) {
      const isChecked = e.target.checked;
      handleOnChange(isChecked);
    }
  };

  const checkboxClass = isFordBrand
    ? styles.checkboxFord
    : styles.checkboxLincoln;
  const hideCheckboxClass = hideCheckbox ? styles.checkboxHidden : "";
  const checkboxStyle = boldCheck ? styles.bold : "";

  const ariaLabelProps = ariaLabel ? { "aria-label": ariaLabel } : {};
  const ariaLabelledbyProps = ariaLabelledby
    ? { "aria-labelledby": ariaLabelledby }
    : {};
  const ariaDescribedbyProps = ariaDescribedby
    ? { "aria-describedby": ariaDescribedby }
    : {};
  const ariaCheckedProps =
    ariaChecked === undefined ? {} : { "aria-checked": ariaChecked };
  const ariaDisabledProps =
    ariaDisabled === undefined ? {} : { "aria-disabled": ariaDisabled };
  const roleProps = role ? { role } : {};

  return (
    <div className={`${hideCheckboxClass} ${styles.checkboxContainer}`}>
      <div className={styles.checkboxWrapper}>
        <input
          disabled={isDisabled}
          type="checkbox"
          id={id}
          className={`${styles.checkbox} ${checkboxClass} ${checkboxStyle}`}
          onChange={handleCheckboxOnChange}
          data-testid={id}
          checked={checked}
          {...ariaLabelProps}
          {...ariaLabelledbyProps}
          {...ariaDescribedbyProps}
          {...ariaCheckedProps}
          {...ariaDisabledProps}
          {...roleProps}
        />
        <label htmlFor={id}>
          <span className={styles.checkboxBox}>
            {checked && (
              <svg
                className={styles.checkboxTick}
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.3332 4L5.99984 11.3333L2.6665 8"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </span>
        </label>
      </div>
      <div className={textClass || styles.label} data-testid={id + "Text"}>
        {label}
      </div>
    </div>
  );
};

CheckBox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  checked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  handleOnChange: PropTypes.func,
  isFordBrand: PropTypes.bool,
  boldCheck: PropTypes.bool,
  hideCheckbox: PropTypes.bool,
  textClass: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaLabelledby: PropTypes.string,
  ariaDescribedby: PropTypes.string,
  ariaChecked: PropTypes.bool,
  ariaDisabled: PropTypes.bool,
  role: PropTypes.string,
};

CheckBox.defaultProps = {
  checked: false,
  isDisabled: false,
  handleOnChange: undefined,
  isFordBrand: true,
  boldCheck: false,
  hideCheckbox: false,
  textClass: "",
  ariaLabel: undefined,
  ariaLabelledby: undefined,
  ariaDescribedby: undefined,
  ariaChecked: undefined,
  ariaDisabled: undefined,
  role: undefined,
};

export default CheckBox;
